import React, { useState, useEffect, lazy, Suspense } from "react"

import { connect } from "react-redux"
import { Flex, Box } from "@rebass/grid/emotion"
import styled from "@emotion/styled"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { TextElement } from "@nutrafol/nutrafol-ui-kit/dist/TextElement"

import MobileLogo from "../../assets/icons/nutrafol-logo-m-full.svg"
import Logo from "./logo"
import BackButton from "./backbutton"
import SaveAndExitButton from "../../components/saveandexitbutton"
import { clearStateAndExit } from "../../utils/clearStateAndExit"
const ProgressBar = lazy(() => import("../../components/progressbar"))

const HeaderWrap = styled.header`
  position: fixed;
  z-index: 4;
  top: 0;
  transition: top 0.2s;
  left: 0;
  right: 0;
  width: 100%;
  height: 85px;
  &.mousedown {
    *:focus {
      outline: none;
    }
  }
  .intro-variant {
    display: none;
  }
  &.intro-mode {
    @media (max-width: 767px) {
      background-image: none;
      > div {
        background-color: rgba(255, 255, 255, 0.2);
        background-image: none;

        border-top: 1px solid rgba(4, 28, 27, 0.2);
        border-bottom: 1px solid rgba(4, 28, 27, 0.2);
        box-shadow: 0 40px 40px 0 rgba(0, 0, 0, 0.03),
          0 20.25px 17.438px 0 rgba(0, 0, 0, 0.02),
          0 8px 6.5px 0 rgba(0, 0, 0, 0.01),
          0 1.75px 2.313px 0 rgba(0, 0, 0, 0.01);
      }
      .intro-default {
        display: none;
      }
      .intro-variant {
        display: flex;
        align-items: center;
      }
      svg {
        height: 18px;
        width: auto;
      }
    }
  }

  @media (min-width: 1024px) {
    height: 145px;
    top: 24px;
    left: 24px;
    right: 24px;
    width: calc(100% - 48px);
  }
  @media (min-width: 1568px) {
    max-width: 1520px;
    left: calc(50% - 760px);
  }
`

const MainHeaderFlex = styled(Flex)`
  background: ${theme.color.white};
  height: 52px;
  border-bottom: 1px #cdd2d1 solid;

  @media (min-width: 768px) {
    height: 56px;
  }
  @media (min-width: 1024px) {
    border: 1px #cdd2d1 solid;
    border-radius: 2px;
    height: 64px;
  }
`

const AlertBox = styled.div`
  background-color: ${theme.wild.color.master.primary.default};
  padding: 8px;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  margin: 16px 8px;
  gap: 8px;

  @media (min-width: 1024px) {
    margin: 30px 0 16px 0;
  }

  svg {
    min-width: 20px;
    width: 20px;
    height: 20px;

    path {
      stroke: white;
    }
  }

  p {
    @media (min-width: 1024px) {
      font-size: 16px !important;
    }
  }
`

const Header = (props) => {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  const showRibbon = false

  return (
    <>
      {!props.interstitial || (props.interstitial && props.showNameGreeting) ? (
        <HeaderWrap
          className={
            (props.isIntroMode ? " intro-mode " : "") +
            (props.mouseDown ? " mousedown " : "") +
            " header-wrapper"
          }
        >
          <MainHeaderFlex
            className="wrap"
            alignItems="center"
            height="100%"
            px={[16, 16, 16, 24]}
          >
            <Box
              width={[
                "calc(50% - 30px)",
                "calc(50% - 30px)",
                "calc(50% - 70px)",
              ]}
              height={[16, 16, 20, 24]}
              className={`intro-default`}
            >
              <BackButton className={`intro-default`} />
            </Box>
            <Box width={["auto"]} className={`intro-default`}>
              <Logo />
            </Box>
            <Box
              width={[
                "calc(50% - 30px)",
                "calc(50% - 30px)",
                "calc(50% - 70px)",
              ]}
              height={[16, 16, 20, 24]}
              className="text-right intro-default"
            >
              <SaveAndExitButton />
            </Box>
            <Box flex={1} className={`intro-variant`}>
              <button className={`cursor-pointer`} onClick={clearStateAndExit}>
                <MobileLogo />
              </button>
            </Box>
            <Box width={["70px"]} className="text-right intro-variant">
              <SaveAndExitButton />
            </Box>
          </MainHeaderFlex>
          {isClient && (
            <Suspense fallback={null}>
              <ProgressBar />
            </Suspense>
          )}

          {props.location?.pathname?.includes("/intro/") && showRibbon && (
            <AlertBox className="flex">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M16.6667 10.4784V16.3478C16.6667 16.5208 16.5964 16.6867 16.4714 16.809C16.3464 16.9313 16.1768 17 16 17H4C3.82319 17 3.65362 16.9313 3.52859 16.809C3.40357 16.6867 3.33333 16.5208 3.33333 16.3478V10.4784M10 6.5654V17M10 6.5654C10 6.5654 12.6567 6.56536 14.0658 5.345C14.89 4.63088 14.8442 3.34938 14.0658 2.58798C13.2875 1.82658 11.9775 1.78175 11.25 2.58798C10 3.96649 10 6.5654 10 6.5654ZM10 6.5654C10 6.5654 7.34332 6.56536 5.93415 5.345C5.10998 4.63088 5.15582 3.34938 5.93415 2.58798C6.71248 1.82658 8.02248 1.78175 8.74998 2.58798C9.99998 3.96649 10 6.5654 10 6.5654ZM2.66667 6.5654H17.3333C17.7015 6.5654 18 6.85739 18 7.21757V9.82621C18 10.1864 17.7015 10.4784 17.3333 10.4784H2.66667C2.29848 10.4784 2 10.1864 2 9.82621V7.21757C2 6.85739 2.29848 6.5654 2.66667 6.5654Z"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <TextElement
                text="Complete the quiz to get your custom hair routine + <span class='font-dinamoBold whitespace-nowrap'>exclusive gifts!</span>"
                element="p"
                className="body--regular text-master-base-default variant-b-"
              />
            </AlertBox>
          )}
        </HeaderWrap>
      ) : null}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    isIntroMode: state.setHeaderVariantReducer.isIntroMode,
    interstitial: state.interstitialReducer.interstitial,
    showNameGreeting: state.revealProgressReducer.showNameGreeting,
  }
}

export default connect(mapStateToProps)(Header)
